// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageCrop_wrapper__3E55V"};